/*
*   主入口
*/

import React , { Component } from 'react';
import { Layout, message, } from 'antd';
import {createBrowserHistory} from 'history';
import $ from 'jquery';
import './css/app.css';
import CNF from './incs/Config';
import { AddRequestHeaders, DeleteCookies, 
    winHeight, winWidth, CurrentTime } from './incs/FunHelper';
import SYHeader from './components/navs/SYHeader';
import SYMenu from './components/navs/SYMenu';

import Area from './components/settings/Area';

import Intersection from './components/intersections/Intersection';
import Timing from './components/intersections/Timing';
import IntersectionImage from './components/intersections/IntersectionImage';
import Walkway from './components/intersections/Walkway';
import WalkwayImage from './components/intersections/WalkwayImage';

import IntersectionID from './components/reports/IntersectionID';
import IntersectionITYEC from './components/reports/IntersectionITYEC';

import AMapLineEditer from './components/lines/AMapLineEditer';
import Line from './components/lines/Line';

import VSDevls from './components/vss/VSDevls';

import LogOperation from './components/logs/LogOpration';
import LogTiming from './components/logs/LogTiming';

const history = createBrowserHistory();

class App extends Component{
    constructor(props){
        super(props);
        this.state = {
            preGroup: 'xzt',
            navLists: [],
            btnLists: '',
            serInfos: [],
            collapsed: false,
            drawerIsOpen: false,
            isFull: false,
            m: this.props.m,
        }
    }
    setCollapsed = () =>{ this.setState({ collapsed: !this.state.collapsed }); }
    setDrawerIsOpen = (value) =>{ this.setState({ drawerIsOpen: value }); }
    setIsFull = () =>{ this.setState({ isFull: !this.state.isFull }); }
    changeNavItemM = (m) =>{ this.setState({ m: m });}

    changeNavItem = (m) =>{
        var com = ''
        switch(m.toString()){
            case '11':
                com = <Area btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '21':
                com = <Intersection btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '22':
                com = <Timing btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '23':
                com = <IntersectionImage btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '24':
                com = <Walkway btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '25':
                com = <WalkwayImage btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '31':
                com = <AMapLineEditer btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '32':
                com = <Line btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '41':
                com = <VSDevls btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '51':
                com = <IntersectionID mod='IDHMC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '52':
                com = <IntersectionID mod='IDINC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '53':
                com = <IntersectionID mod='IDDEC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '54':
                com = <IntersectionID mod='IDREC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '55':
                com = <IntersectionID mod='IDSTC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '56':
                com = <IntersectionITYEC mod='ITYTC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '57':
                com = <IntersectionID mod='IDOPC' btnLists={this.state.btnLists} preGroup={this.state.preGroup}/>;
                break;
            case '61':
                com = <LogOperation />;
                break;
            case '62':
                com = <LogTiming />;
                break;
            default:
                break;
        }
        return com
    }

    /**
     * 获取用户策略
     */
    getPolicys = () =>{
        const _this = this;
        $.ajax({
            url: `${CNF.api}policys`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function(data){
                if(data.res === 0){
                    _this.setState({
                        preGroup: data.dat.pre_group,
                        navLists: data.dat.nav_lists,
                        btnLists: data.dat.btn_lists,
                        serInfos: data.dat.ser_infos,
                    });
                }else{
                    message.error(data.msg, 1.5);
                    setTimeout(function(){
                        //  若获取策略失败，直接退出登录
                        DeleteCookies();
                    }, 1500);
                }
            }
        });
    }

    componentDidUpdate(){
        //  更新 url
        if(this.state.m > 10){
            var i = Math.floor(parseInt(this.state.m) / 10);
            var j = parseInt(this.state.m % 10)
            history.push(CNF.basename?`${CNF.basename}${CNF.navItems[i].submenu[j].url}`:CNF.navItems[i - 1].submenu[j - 1].url);
        }else{
            history.push(CNF.basename?`${CNF.basename}${CNF.navItems[this.state.m].url}`:CNF.navItems[this.state.m - 1].url);
        }   
    }

    componentDidMount(){
        this.getPolicys();
    }

  render(){
        return(
            <>
                <div style={{ 
                    position: 'absolute', 
                    textAlign: 'center', 
                    fontSize:'11px',
                    background: 'linear-gradient(to right,#FF904D,#1677FF)',
                    width: winWidth-(this.state.collapsed?80:200),
                    height: '16px',
                    display: this.state.serInfos.length>0&&CurrentTime()<this.state.serInfos[0].cutoff_time?'block':'none',
                    marginLeft: this.state.collapsed?80:200,
                    zIndex: 0
                }}
                >{this.state.serInfos.length>0?this.state.serInfos[0].content:''}</div>
                <Layout style={{height: winHeight}}>
                    <SYMenu 
                        btnLists={this.state.btnLists}
                        collapsed={this.state.collapsed} 
                        changeNavItemM={this.changeNavItemM} 
                        m={this.state.m}
                    />
                    <Layout className='site-layout'>
                        <SYHeader collapsed={this.state.collapsed} setCollapsed={this.setCollapsed} navLists={this.state.navLists}/>
                        {
                            this.changeNavItem(this.state.m)
                        }
                        <div className='area-content' id='area-content-id'></div>
                    </Layout>
                </Layout>
            </>
        );
    }
}

export default App